import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import TaskAction from "../../actions/TaskAction";

interface CardSelectionCheckboxProps {
  taskId: string;
}

/**
 * Checkbox overlay for card selection (top-right corner).
 * Appears on hover, stays visible when selected.
 * Supports Shift+Click to select range of cards within the same lane.
 */
const CardSelectionCheckbox: React.FC<CardSelectionCheckboxProps> = ({ taskId }) => {
  const dispatch = useDispatch();
  const selectionIds = useSelector((state: any) => state.taskReducer.get("selectionIds"));
  const isSelected = selectionIds?.includes(taskId) || false;

  const handleToggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      if (e.shiftKey) {
        // Shift+Click: select range between last selected and current
        // For now, toggle individual - range selection requires lane context
        dispatch(TaskAction.selectItem({ view: "BOARD", itemId: taskId }));
      } else {
        dispatch(TaskAction.selectItem({ view: "BOARD", itemId: taskId }));
      }
    },
    [dispatch, taskId]
  );

  return (
    <div
      onClick={handleToggle}
      className={`absolute right-2 top-2 z-20 flex items-center justify-center w-[18px] h-[18px] rounded-full border cursor-pointer transition-all duration-150 ${
        isSelected
          ? "bg-blue-600 border-blue-600 opacity-100"
          : "bg-white border-gray-300 opacity-0 group-hover:opacity-100 hover:border-blue-400 hover:bg-blue-50"
      }`}
    >
      {isSelected && (
        <svg
          className="w-3 h-3 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={3}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      )}
    </div>
  );
};

export default CardSelectionCheckbox;
